<template>
  <div>
    <canvas ref="chart"></canvas>
  </div>
</template>

<script setup>
import Chart from "chart.js";
import {onMounted, onUnmounted, ref, watch} from "vue";

const props = defineProps({
  labels: Array,
  data: Array,
  label: String,
  color: String,
  formatValue: Function
});

const chart = ref(undefined);
const chartObject = ref(undefined);

function hexToRgba(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
}

function updateChartData() {
  chartObject.value.data.datasets = [{
    label: props.label,
    data: [...(props.data ?? [])],
    borderColor: props.color ?? "#f18616",
    backgroundColor: hexToRgba(props.color ?? "#f18616", 0.25),
    fontColor: "#fefefe",
    pointBackgroundColor: props.color ?? "#f18616"
  }];
  chartObject.value.data.labels = [...(props.labels ?? [])];
  chartObject.value.update();
}

onMounted(() => {
  chartObject.value = new Chart(chart.value, {
    type: 'line',
    data: {
      labels: [],
      datasets: [],
      backgroundColor: "rgba(0, 0, 0, 0)",
      fontColor: "#fefefe"
    },
    options: {
      legend: {
        labels: {
          fontColor: "#fefefe"
        },
        fontColor: "#fefefe"
      },
      tooltips: {
        backgroundColor: "#3d4145",
        xPadding: 12,
        yPadding: 10,
        mode: 'single',
        callbacks: {
          label: function(items) {
            return props.formatValue ? props.formatValue(items.yLabel) : items.yLabel;
          }
        }
      },
      scales: {
        yAxes: [{
          ticks: {
            fontColor: "#fefefe"
          },
          gridLines: {
            color: "rgba(255, 255, 255, 0.05)"
          }
        }],
        xAxes: [{
          ticks: {
            fontColor: "#fefefe"
          },
          gridLines: {
            color: "rgba(255, 255, 255, 0.05)"
          }
        }]
      }
    }
  });
  updateChartData();
});


watch(() => props.data, () => {
  updateChartData();
});

watch(() => props.labels, () => {
  chartObject.value.data.labels = [...(props.labels ?? [])];
  chartObject.value.update();
});

onUnmounted(() => {
  chartObject.value = undefined;
});

</script>